import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './absolute-spinner.module.scss';

@classic
@classNames('absolute-spinner', styles.component)
export default class SharedAbsoluteSpinner extends Component {}
